import React from 'react';
import { normaliseTheme } from '../../../themes';

// Booking page panel — controls that change how the customer-facing
// /shop/:subdomain/book page renders. Sits directly under Hero image
// so the two hero-related controls live together.
//
// Only the Instacut default theme reads these flags today; locked
// themes render their own booking hero regardless, so the panel is
// hidden on those to avoid confusing the operator with an inert
// toggle.
//
// Options:
//   • Inherit hero — reuse the landing page hero as the booking page
//     background. When OFF (default) the booking page falls back to
//     the theme's own top block (accent / black).
export const BookingPagePanel = ({ form, onChange }) => {
  if (normaliseTheme(form.theme) !== 'instacut-default') return null;

  const hasHero = !!form.hero_image_url;
  const checked = !!form.booking_inherit_hero;

  return (
    <div className="panel" style={{ padding: 18, marginBottom: 14 }} data-testid="booking-page-panel">
      <div className="field" style={{ marginBottom: 0 }}>
        <label>Booking page
          <span className="hint"> — how the booking page looks to customers</span>
        </label>
        <label
          style={{
            display: 'flex',
            gap: 10,
            alignItems: 'flex-start',
            marginTop: 8,
            cursor: hasHero ? 'pointer' : 'not-allowed',
            opacity: hasHero ? 1 : 0.55,
          }}
          data-testid="booking-inherit-hero-row"
        >
          <input
            type="checkbox"
            checked={checked}
            disabled={!hasHero}
            onChange={(e) => onChange({ booking_inherit_hero: e.target.checked })}
            data-testid="booking-inherit-hero-checkbox"
            style={{ marginTop: 3, flex: '0 0 auto' }}
          />
          <span>
            <b style={{ display: 'block', fontSize: 13 }}>Inherit hero</b>
            <span className="hint" style={{ fontSize: 11.5, display: 'block', marginTop: 2 }}>
              {hasHero
                ? 'Use the same hero image on the booking page. Leave unchecked for the default booking theme background.'
                : 'Upload a hero image above first to enable this option.'}
            </span>
          </span>
        </label>
      </div>
    </div>
  );
};
